<div class="panel-body glebas-tab">
  <table class="table table-striped table-condensed">
    <thead>
      <tr>
        <th>Sementes de origem</th>
        <th>Sementes de destino</th>
        <th colspan="3">Qtde</th>
      </tr>
    </thead>
    <tfoot>
      <tr>
        <td class="cultura-field">
          <div class="form-group">
            <ui-select ng-model="tratamentoSemeadura.tempTratamento.cultivar" ng-change="tratamentoSemeadura.setAttributesCultivar()" theme="bootstrap">
              <ui-select-match allow-clear="false" placeholder="Semente de origem">{{$select.selected.descricao | characters:30}}</ui-select-match>
              <ui-select-choices repeat="cultivarOrigem in tratamentoSemeadura.cultivaresTratamento"
                                 refresh="tratamentoSemeadura.searchCultivaresTratamento($select)"
                                 refresh-delay="300">
                <span class="form-group" ng-bind-html="cultivarOrigem.descricao | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </td>
        <td class="cultura-field">
          <div class="form-group">
            <ui-select ng-disabled="!tratamentoSemeadura.canSelectCultivarDestino()" ng-model="tratamentoSemeadura.tempTratamento.cultivarDestino" theme="bootstrap">
              <ui-select-match allow-clear="false" placeholder="Semente de destino">{{$select.selected.descricao | characters:30}}</ui-select-match>
              <ui-select-choices repeat="cultivarDestino in tratamentoSemeadura.cultivaresDestinoDisponivel | filter: $select.search | limitTo: 50">
                <span class="form-group" ng-bind-html="cultivarDestino.descricao | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </td>
        <td class="kg-field">
          <div class="form-group">
            <input type="number" ng-model="tratamentoSemeadura.tempTratamento.totalKg"
                   class="form-control" auto-step min="0" placeholder="Quantidade" string-to-number
                   uib-tooltip="Total para tratamento maior que o recomendado" tooltip-is-open="tratamentoSemeadura.kgTratamentoExceeded()"
                   tooltip-placement="bottom" tooltip-trigger="none">
          </div>
        </td>
        <td class="copy-field">
          <div class="form-group">
            <ui-select ng-model="tratamentoSemeadura.tempTratamento.copyFrom" ng-disabled="!tratamentoSemeadura.canCopy()">
              <ui-select-match allow-clear="true" placeholder="Copiar de outra semente">{{$select.selected.cultivar.descricao | characters: 30}}</ui-select-match>
              <ui-select-choices repeat="cultivar in tratamentoSemeadura.recomendacao.tratamentos | filter: {cultivar: {descricao: $select.search}}">
                <span class="form-group" ng-bind-html="cultivar.cultivar.descricao | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </td>
        <td>
          <button type="button" class="btn btn-link" ng-click="tratamentoSemeadura.addTratamento()" ng-disabled="tratamentoSemeadura.addTratamentoDisabled()">Adicionar</button>
          <button type="button" class="btn btn-link text-warning" ng-click="tratamentoSemeadura.cancelEditTratamento(tratamentoSemeadura)" ng-if="!tratamentoSemeadura.editing">Cancelar</button>
        </td>
      </tr>
    </tfoot>
    <tbody>
      <tr ng-repeat-start="tratamento in tratamentoSemeadura.recomendacao.tratamentos track by $index">
        <td>{{tratamento.cultivar.descricao}}</td>
        <td>{{tratamento.cultivarDestino.descricao}}</td>
        <td>{{tratamento.totalKg | number:2}}</td>
        <td class="text-right" colspan="2">
          <div ng-show="!gleba._edit">
            <button type="button" class="btn btn-link text-info" ng-click="tratamentoSemeadura.editTratamento(tratamento)"><i class="fa fa-edit"></i></button>
            <button type="button" class="btn btn-link text-danger" ng-click="tratamentoSemeadura.deleteTratamento($index)"><i class="fa fa-trash"></i></button>
          </div>
        </td>
      </tr>
      <tr ng-repeat-end>
        <td></td>
        <td colspan="3">
          <table class="table table-striped table-condensed">
            <thead>
              <tr>
                <th>Defensivos</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <td>
                  <div class="form-group no-margin">
                    <ui-select ng-model="tratamentoSemeadura.produto.selected" on-select="tratamentoSemeadura.addProduto($item, tratamento)" theme="bootstrap" id="produtos" name="produtos">
                      <ui-select-match placeholder="Pesquisar produto">{{$select.selected.descricao}}</ui-select-match>
                      <ui-select-choices repeat="produto in tratamentoSemeadura.produtos" refresh="tratamentoSemeadura.searchProdutos($select, tratamento)" refresh-delay="300">
                        <div ng-bind-html="produto.descricao | highlight: $select.search"></div>
                        <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
                          <small ng-bind-html="'Físico: ' + (produto.saldo_fisico | number:4) + ' ' + (produto.unidade.abreviatura)"></small><br>
                          <small ng-bind-html="'A Receber: ' + (produto.saldo_receber | number:4) + ' ' + (produto.unidade.abreviatura)"></small><br>
                          <small ng-bind-html="'Em Uso: ' + (produto.saldo_em_uso | number:4) + ' ' + (produto.unidade.abreviatura)"></small>
                        </span>
                      </ui-select-choices>
                    </ui-select>
                    <small class="help-block" ng-show="tratamentoSemeadura.searchProduto.length && !tratamento.loadingProdutos && !tratamentoSemeadura.produtos">
                      Informe pelo menos 3 caracteres
                    </small>
                    <span class="input-group-addon no-border no-background" ng-show="tratamento.loadingProdutos">
                      <i class="fa fa-spinner fa-spin"></i>
                    </span>
                    <span class="input-group-addon no-border no-background" ng-show="!tratamento.loadingProdutos && tratamentoSemeadura.produtos.length === 0">
                      Não encontrado
                    </span>
                  </div>
                </td>
                <td>
                  <button type="button" class="btn btn-white" title="Ver todos os produtos" ng-click="tratamentoSemeadura.openProductModal(tratamento)">
                    <i class="fa fa-external-link"></i>
                  </button>
                </td>
              </tr>
            </tfoot>
            <tbody>
              <tr ng-repeat="produto in tratamento.insumos track by produto.id">
                <td>
                  <div class="input-group width-90 pull-left">
                    <span class="input-group-addon no-padding width-40" uib-tooltip="{{produto.descricao}}" tooltip-append-to-body="true" tooltip-placement="left">
                      {{produto.descricao | characters:50}}
                    </span>
                    <input class="form-control p-xxs" placeholder="Dose" ng-model="produto.dose" type="number" string-to-number auto-step ng-pattern="/^[0-9]+(\.[0-9]{1,4})?$/">
                    <span class="input-group-addon">{{produto.unidadeSelected.abreviatura || 'Unid.'}}/{{tratamentoSemeadura.isCorn ? 'un' : '100kg'}}</span>
                  </div>
                </td>
                <td>
                  <span type="button" class="btn width-10 pull-right p-xxs" ng-click="tratamentoSemeadura.removeProduto($index, tratamento)">
                    <i class="fa fa-times fa-lg" aria-hidden="true"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

        </td>
      </tr>
    </tbody>
  </table>

</div>
